import React, { FC } from 'react';
import Plate1 from '../../assets/plate1.png';
import Plate2 from '../../assets/plate2.png';
import Plate3 from '../../assets/plate3.png';
import Plate4 from '../../assets/plate4.png';
import Plate5 from '../../assets/plate5.png';
import styled from 'styled-components';
import { lightTheme } from '../../styles/theme';
import { useTranslation } from '../../lang/TranslationContext';
import useWindowDimensions from '../../hooks/useWindowDimensions';

type PlateBlockProps = {
	step: number;
};

export const PlateBlock: FC<PlateBlockProps> = ({ step }) => {
	const { translations } = useTranslation();
	const { width } = useWindowDimensions();

	const PLATES = [
		{
			img: Plate1,
			title: 'Day Type metrix',
			description: [
				translations.landing.plates.plate1.text1,
				translations.landing.plates.plate1.text2,
				translations.landing.plates.plate1.text3,
				translations.landing.plates.plate1.text4,
			],
		},
		{
			img: Plate2,
			title: 'Session metrix',
			description: [
				translations.landing.plates.plate2.text1,
				translations.landing.plates.plate2.text2,
				translations.landing.plates.plate2.text3,
			],
		},
		{
			img: Plate3,
			title: 'Daily & Common metrix',
			description: [
				translations.landing.plates.plate3.text1,
				translations.landing.plates.plate3.text2,
			],
		},
		{
			img: Plate4,
			title: 'Initial Balance metrix',
			description: [translations.landing.plates.plate4.text1],
		},
		{
			img: Plate5,
			title: 'RTH, TPO & ORB metrix',
			description: [
				translations.landing.plates.plate5.text1,
				translations.landing.plates.plate5.text2,
			],
		},
	];

	return (
		<Wrap isMobile={width < 800}>
			<InnerWrap>
				<div>
					<h1>{PLATES[step - 1].title}</h1>
					{PLATES[step - 1].description.map((i) => (
						<p key={i}>{i}</p>
					))}
				</div>
				<div>
					<img src={PLATES[step - 1].img} alt="plate" />
				</div>
			</InnerWrap>
		</Wrap>
	);
};

const Wrap = styled.div<{ isMobile?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: ${({ isMobile }) => (isMobile ? '800px' : '100vh')};
`;

const InnerWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 1440px;
	gap: 200px;
	padding: 0 40px;

	> div {
		width: 50%;
		max-height: 70vh;

		&:nth-of-type(2) {
			width: 473px;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		h1 {
			font-size: 36px;
			color: ${lightTheme.typography.primary};
			font-weight: 600;
		}

		p {
			font-size: 16px;
			font-weight: 400;
			color: ${lightTheme.typography.tetriary};
			line-height: 24px;
			margin-top: 18px;
		}
	}

	@media screen and (max-width: 1000px) {
		gap: 100px;
	}

	@media screen and (max-width: 800px) {
		gap: 10px;
		flex-direction: column-reverse;
		padding: 0 20px;

		> div {
			width: 100%;

			&:nth-of-type(2) {
				width: auto;
				height: 350px;
			}
		}
	}
`;
